'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var reactRouterDom = require('react-router-dom');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');
var index$1 = require('../../components/Language/index.js');
var Spinner = require('../../components/Spinner/Spinner.js');
require('../../components/LocationCard/LocationCard.js');
require('../../components/PudoCard/PudoCard.js');
var ItemCard = require('../../components/ItemCard/ItemCard.js');
require('../../components/SelectItem/SelectItem.js');
require('../../components/SelectList/SelectList.js');
require('../../components/ErrorBanner/ErrorBanner.js');
var Footer = require('../../components/Footer/Footer.js');
var StickyFooter = require('../../components/StickyFooter/StickyFooter.js');
require('../../components/SwatchesList/SwatchesList.js');
var index$3 = require('../../components/TextLink/index.js');
require('../../components/Backdrop/Backdrop.module.css.js');
var index$2 = require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/Skeleton.module.css.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');
var helper = require('./helper.js');
var tokens = require('./tokens.js');
var index = require('../../components/StyledMarkup/index.js');
var style = require('../../transformers/style.js');
var features = require('../../utils/features.js');
var ItemSelector_module = require('./ItemSelector.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const ItemSelectorRawC = _ref => {
  let {
    title,
    customer,
    lineItemGroupings,
    itemGroupingModeEnabled,
    eligibleItems,
    onClick,
    onSubmit,
    submittedReturns = [],
    ineligibleItems,
    selectedItems,
    features: features$1 = {},
    onCancel,
    cancelReturnStatus,
    progressiveStep,
    activeStep,
    banner,
    disclaimer,
    locale,
    includeCurrency
  } = _ref;
  const [selectedLineItemGroup, setSelectedLineItemGroup] = React__default["default"].useState();
  const [lineItemGroupReordered, setLineItemGroupReordered] = React__default["default"].useState(lineItemGroupings);
  const {
    itemDisplay
  } = nthHookSettings.useSettings();
  const {
    returnsItemListItemInfoskuLabel,
    returnsItemListItemInfopriceLabel,
    returnsItemListItemInfoqtyLabel,
    returnsItemListItemInfocolorLabel,
    returnsItemListItemInfosizeLabel,
    returnsItemListItemInforeasonLabel,
    returnsItemListSubmit,
    returnsItemListIneligibleTitle,
    returnsItemListTitleDirty,
    returnsItemListTitleDirtyHipaa,
    returnsItemListTitleHipaa,
    returnsItemListTitle,
    returnsActionsBackToLogin,
    returnsItemListReturnInitiatedTitle,
    returnsItemListIneligibleDescription
  } = nthHookTranslations.useTranslations();
  const {
    rawValue: rawSkuLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoskuLabel'
  });
  const skuLabel = returnsItemListItemInfoskuLabel ?? rawSkuLabel;
  const {
    rawValue: rawPriceLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfopriceLabel'
  });
  const priceLabel = returnsItemListItemInfopriceLabel ?? rawPriceLabel;
  const {
    rawValue: rawQtyLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoqtyLabel'
  });
  const qtyLabel = returnsItemListItemInfoqtyLabel ?? rawQtyLabel;
  const {
    rawValue: rawColorLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfocolorLabel'
  });
  const colorLabel = returnsItemListItemInfocolorLabel ?? rawColorLabel;
  const {
    rawValue: rawSizeLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfosizeLabel'
  });
  const sizeLabel = returnsItemListItemInfosizeLabel ?? rawSizeLabel;
  const {
    rawValue: rawReasonLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInforeasonLabel'
  });
  const reasonLabel = returnsItemListItemInforeasonLabel ?? rawReasonLabel;
  const {
    rawValue: rawSubmitLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListSubmit'
  });
  const submitLabel = returnsItemListSubmit ?? rawSubmitLabel;

  // if shopify collective is enabled, we want to group return-eligible items by
  // fulfillment service and only allow same service items to be selected. also
  // want any previously selected items at the top of the queue.
  React__default["default"].useEffect(() => {
    if (!(lineItemGroupings !== null && lineItemGroupings !== void 0 && lineItemGroupings.length) || !(selectedItems !== null && selectedItems !== void 0 && selectedItems.length) || !itemGroupingModeEnabled) return;
    if ((selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0) {
      var _lineItemGroupings$fi;
      const selectedGroupId = (_lineItemGroupings$fi = lineItemGroupings.find(iGroup => {
        var _iGroup$lineItemIds;
        return (_iGroup$lineItemIds = iGroup.lineItemIds) === null || _iGroup$lineItemIds === void 0 ? void 0 : _iGroup$lineItemIds.find(lineItemId => lineItemId === selectedItems[0].itemId);
      })) === null || _lineItemGroupings$fi === void 0 ? void 0 : _lineItemGroupings$fi.slug;
      setSelectedLineItemGroup(selectedGroupId);
      const newLineItemsOrder = lineItemGroupings.reduce((newOrdering, currentGroup) => {
        var _currentGroup$lineIte;
        const isSelectedGroup = (_currentGroup$lineIte = currentGroup.lineItemIds) === null || _currentGroup$lineIte === void 0 ? void 0 : _currentGroup$lineIte.find(itemId => itemId === selectedItems[0].itemId);
        if (isSelectedGroup) {
          var _currentGroup$lineIte2;
          const reorderedLineItems = (_currentGroup$lineIte2 = currentGroup.lineItemIds) === null || _currentGroup$lineIte2 === void 0 ? void 0 : _currentGroup$lineIte2.reduce((newOrder, currentId) => {
            if (selectedItems.find(item => item.itemId === currentId)) {
              newOrder.unshift(currentId);
            } else newOrder.push(currentId);
            return newOrder;
          }, []);
          newOrdering.unshift({
            ...currentGroup,
            lineItemIds: reorderedLineItems
          });
        } else newOrdering.push(currentGroup);
        return newOrdering;
      }, []);
      setLineItemGroupReordered(newLineItemsOrder);
    }
  }, [selectedItems, lineItemGroupings, itemGroupingModeEnabled]);
  const handleClick = item => {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      value: {
        item
      },
      event: 'click',
      area: 'itemPicker',
      subComponent: 'itemPickerList'
    });
  };
  const handleSubmit = () => {
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
      value: {},
      event: 'submit',
      area: 'itemPicker',
      subComponent: 'itemPickerList'
    });
  };
  const handleCancel = submittedReturn => {
    onCancel === null || onCancel === void 0 ? void 0 : onCancel({
      value: {
        submittedReturn
      },
      event: 'click',
      area: 'itemPicker',
      subComponent: 'submittedReturn'
    });
  };
  const handleReturnToLogin = () => {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      value: {},
      event: 'click',
      area: 'itemPicker',
      subComponent: 'returnToLogin'
    });
  };
  const {
    isHipaaCompliant
  } = ReturnsConfigProvider.useReturnsConfig();
  const {
    panelcontainerNoneNone: sDefault,
    linksNoneDefault,
    linksNoneHover,
    buttonsPrimaryDefault,
    bodytextDefaultNone,
    selecteditemNoneNone,
    documentbodyNoneNone
  } = nthHookTheme.useTheme();
  const {
    returnToLogin
  } = features.useFeature(features$1, 'returnToLogin');
  const noVisible = [eligibleItems.length === 0, ineligibleItems.length === 0, submittedReturns.length === 0].every(e => e);
  const getReturnsItemListTitle = _ref2 => {
    let {
      eligibleItems,
      selectedItems,
      isHipaaCompliant = false
    } = _ref2;
    if (eligibleItems.length === 0) {
      return {
        defaultString: typeof returnsItemListIneligibleTitle === 'string' ? returnsItemListIneligibleTitle : undefined,
        langKey: 'returnsItemListIneligibleTitle'
      };
    }
    if (((selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) ?? 0) > 0) {
      return isHipaaCompliant ? {
        defaultString: typeof returnsItemListTitleDirtyHipaa === 'string' ? returnsItemListTitleDirtyHipaa : undefined,
        langKey: 'returnsItemListTitleDirtyHipaa'
      } : {
        defaultString: typeof returnsItemListTitleDirty === 'string' ? returnsItemListTitleDirty : undefined,
        langKey: 'returnsItemListTitleDirty'
      };
    }
    return isHipaaCompliant ? {
      defaultString: typeof returnsItemListTitleHipaa === 'string' ? returnsItemListTitleHipaa : undefined,
      langKey: 'returnsItemListTitleHipaa'
    } : {
      defaultString: typeof returnsItemListTitle === 'string' ? returnsItemListTitle : undefined,
      langKey: 'returnsItemListTitle'
    };
  };
  const itemListTitleObj = getReturnsItemListTitle({
    eligibleItems,
    selectedItems,
    isHipaaCompliant
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, banner, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    containerCustomStyle: {
      margin: '2rem auto'
    }
  }, title ? /*#__PURE__*/React__default["default"].createElement(index["default"], {
    content: title
  }) : /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    noWrap: true,
    langKey: itemListTitleObj.langKey,
    defaultString: itemListTitleObj.defaultString,
    replacementTokens: [{
      token: '{{customer}}',
      value: (customer === null || customer === void 0 ? void 0 : customer.firstName) ?? (customer === null || customer === void 0 ? void 0 : customer.lastName) ?? (customer === null || customer === void 0 ? void 0 : customer.fullName) ?? ''
    }]
  })), noVisible && returnToLogin && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: handleReturnToLogin
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsActionsBackToLogin",
    defaultString: returnsActionsBackToLogin
  })), itemGroupingModeEnabled && lineItemGroupReordered !== null && lineItemGroupReordered !== void 0 && lineItemGroupReordered.length ? lineItemGroupReordered.map(iGroup => /*#__PURE__*/React__default["default"].createElement(index$2.LineItemsGroup, {
    selectedGroup: iGroup.slug === selectedLineItemGroup,
    itemsWereSelected: Boolean(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length),
    key: iGroup.slug
  }, eligibleItems.filter(item => {
    var _iGroup$lineItemIds2;
    return iGroup === null || iGroup === void 0 ? void 0 : (_iGroup$lineItemIds2 = iGroup.lineItemIds) === null || _iGroup$lineItemIds2 === void 0 ? void 0 : _iGroup$lineItemIds2.includes(item.itemId || '');
  }).map(item => {
    var _item$availableReason;
    const selectedItem = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.find(_ref3 => {
      let {
        sku,
        itemId,
        localId
      } = _ref3;
      return item.sku === sku && item.itemId === itemId && item.localId === localId;
    });
    const selectedReason = selectedItem && ((_item$availableReason = item.availableReasons) === null || _item$availableReason === void 0 ? void 0 : _item$availableReason.find(reason => reason.id === selectedItem.reason.id));
    const exchangeTo = selectedItem && 'exchangeTo' in selectedItem ? selectedItem.exchangeTo : undefined;
    return /*#__PURE__*/React__default["default"].createElement(ItemCard.ItemCard, _extends__default["default"]({}, helper.getItemProps({
      item,
      exchangeTo
    }), {
      attributes: helper.getItemAttrs({
        locale,
        includeCurrency,
        item: {
          ...item,
          quantity: item.remainingQuantity
        },
        itemDisplay,
        selectedQuantity: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.quantity,
        labels: {
          skuLabel,
          priceLabel,
          qtyLabel,
          colorLabel,
          sizeLabel
        },
        exchangeTo
      }),
      additionalInfo: selectedReason && `${reasonLabel ?? ''}${(selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.name) ?? ''}`,
      hasShippingProtection: item.hasShippingProtection,
      key: `${item.sku ?? ''}${item.itemId ?? ''}${item.localId ?? 0}`,
      onClick: () => handleClick(item),
      selected: Boolean(selectedItem),
      clickable: !(selectedItems !== null && selectedItems !== void 0 && selectedItems.length) || iGroup.slug === selectedLineItemGroup,
      disabled: Boolean(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) && iGroup.slug !== selectedLineItemGroup,
      sDefault: {
        ...sDefault,
        backgroundColor: documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor
      },
      sActive: selecteditemNoneNone,
      sTag: {
        ...selecteditemNoneNone,
        borderRadius: 0,
        borderTopLeftRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderTopLeftRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 4,
        borderBottomRightRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3,
        backgroundColor: style.getBorderColor(selecteditemNoneNone) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor)
      }
    }));
  }))) : eligibleItems.map(item => {
    var _item$availableReason2;
    const selectedItem = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.find(_ref4 => {
      let {
        sku,
        itemId,
        localId
      } = _ref4;
      return item.sku === sku && item.itemId === itemId && item.localId === localId;
    });
    const selectedReason = selectedItem && ((_item$availableReason2 = item.availableReasons) === null || _item$availableReason2 === void 0 ? void 0 : _item$availableReason2.find(reason => reason.id === selectedItem.reason.id));
    const exchangeTo = selectedItem && 'exchangeTo' in selectedItem ? selectedItem.exchangeTo : undefined;
    return /*#__PURE__*/React__default["default"].createElement(ItemCard.ItemCard, _extends__default["default"]({}, helper.getItemProps({
      item,
      exchangeTo,
      isClaim: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.isClaim
    }), {
      attributes: helper.getItemAttrs({
        locale,
        includeCurrency,
        item: {
          ...item,
          quantity: item.remainingQuantity
        },
        itemDisplay,
        selectedQuantity: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.quantity,
        labels: {
          skuLabel,
          priceLabel,
          qtyLabel,
          colorLabel,
          sizeLabel
        },
        exchangeTo
      }),
      additionalInfo: selectedReason && `${reasonLabel ?? ''}${(selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.name) ?? ''}`,
      hasShippingProtection: item.hasShippingProtection,
      key: `${item.sku ?? ''}${item.itemId ?? ''}${item.localId ?? 0}`,
      onClick: () => handleClick(item),
      selected: Boolean(selectedItem),
      clickable: true,
      sDefault: {
        ...sDefault,
        backgroundColor: documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor
      },
      sActive: selecteditemNoneNone,
      sTag: {
        ...selecteditemNoneNone,
        borderRadius: 0,
        borderTopLeftRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderTopLeftRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 4,
        borderBottomRightRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3,
        backgroundColor: style.getBorderColor(selecteditemNoneNone) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor)
      }
    }));
  })), submittedReturns === null || submittedReturns === void 0 ? void 0 : submittedReturns.map(submittedReturn => {
    var _submittedReturn$retu;
    const isBeingCancelled = (cancelReturnStatus === null || cancelReturnStatus === void 0 ? void 0 : cancelReturnStatus.status) === 'loading' && (cancelReturnStatus === null || cancelReturnStatus === void 0 ? void 0 : cancelReturnStatus.returnId) === submittedReturn.id;
    const showReturnLabelActions = !isHipaaCompliant;
    const showShipmentActions = showReturnLabelActions || submittedReturn.canBeCancelled;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: submittedReturn.id
    }, (_submittedReturn$retu = submittedReturn.returnShipments) === null || _submittedReturn$retu === void 0 ? void 0 : _submittedReturn$retu.map((shipment, i) => {
      const actions = shipment.returnShipmentActions ?? [];
      if (!shipment.returnShipmentActions) {
        if (showReturnLabelActions) {
          shipment.returnLabels.forEach(label => {
            if (!label.labelUrl) return;
            if (label.labelType === 'QR_CODE' && submittedReturn.shippingLabelInfoToken) {
              actions.push({
                target: '_blank',
                to: `/printerless-info?return_id=${submittedReturn.shippingLabelInfoToken}`,
                langKey: `returnsItemListPending${label.labelType.toLowerCase()}Link`
              });
            } else {
              actions.push({
                href: label.labelUrl,
                langKey: `returnsItemListPending${label.labelType.toLowerCase()}Link`
              });
            }
          });
        }
        if (submittedReturn.canBeCancelled) {
          actions.push({
            langKey: 'returnsItemListPendingCancelReturnLink',
            onClick: () => {
              if (isBeingCancelled) return;
              handleCancel(submittedReturn);
            },
            status: (cancelReturnStatus === null || cancelReturnStatus === void 0 ? void 0 : cancelReturnStatus.returnId) === submittedReturn.id ? cancelReturnStatus : undefined
          });
        }
      }
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: ItemSelector_module["default"].shipmentWrapper,
        key: i
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: ItemSelector_module["default"].shipmentHeader
      }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, submittedReturn.displayStatus ? /*#__PURE__*/React__default["default"].createElement(index["default"], {
        content: submittedReturn.displayStatus
      }) : /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
        noWrap: true,
        langKey: "returnsItemListReturnInitiatedTitle",
        defaultString: returnsItemListReturnInitiatedTitle
      })), showShipmentActions && /*#__PURE__*/React__default["default"].createElement("ul", {
        className: ItemSelector_module["default"].shipmentActionsWrapper
      }, actions.map((_ref5, j) => {
        let {
          title,
          href,
          langKey,
          status,
          to,
          ...props
        } = _ref5;
        return /*#__PURE__*/React__default["default"].createElement("li", {
          className: ItemSelector_module["default"].shipmentAction,
          key: j
        }, to ? /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Link, _extends__default["default"]({
          to: to || ''
        }, props), title ? /*#__PURE__*/React__default["default"].createElement(index["default"], {
          noWrap: true,
          content: title
        }) : /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
          noWrap: true,
          langKey: langKey ?? ''
        })) : /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
          href: href,
          linkStyle: {
            sDefault: {
              ...linksNoneDefault,
              color: bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.color,
              ...((status === null || status === void 0 ? void 0 : status.status) === 'loading' ? {
                cursor: 'not-allowed',
                opacity: 0.5
              } : undefined)
            },
            sHover: {
              ...linksNoneHover,
              color: bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.color,
              ...((status === null || status === void 0 ? void 0 : status.status) === 'loading' ? {
                cursor: 'not-allowed',
                opacity: 0.5
              } : undefined)
            }
          },
          onClick: props.onClick
        }, title ? /*#__PURE__*/React__default["default"].createElement(index["default"], {
          noWrap: true,
          content: title
        }) : /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
          noWrap: true,
          langKey: langKey ?? ''
        })), (status === null || status === void 0 ? void 0 : status.status) === 'loading' && /*#__PURE__*/React__default["default"].createElement("span", {
          className: ItemSelector_module["default"].spinnerContainer
        }, /*#__PURE__*/React__default["default"].createElement(Spinner["default"], {
          width: 12
        })));
      }))), /*#__PURE__*/React__default["default"].createElement("div", {
        className: ItemSelector_module["default"].shipmentItems
      }, shipment.items.map(item => {
        var _item$reason;
        return /*#__PURE__*/React__default["default"].createElement(ItemCard.ItemCard, {
          thumbnail: item.imageUrl,
          title: item.name,
          attributes: helper.getItemAttrs({
            locale,
            includeCurrency,
            item,
            itemDisplay,
            labels: {
              skuLabel,
              qtyLabel,
              colorLabel,
              sizeLabel
            }
          }),
          hasShippingProtection: item.hasShippingProtection,
          key: `${item.sku ?? ''}${item.itemId ?? ''}`,
          disabled: true,
          sDefault: {
            ...sDefault,
            backgroundColor: documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor
          },
          additionalInfo: `${reasonLabel ?? ''}${(_item$reason = item.reason) === null || _item$reason === void 0 ? void 0 : _item$reason.name}`
        });
      })));
    }));
  }), ineligibleItems.length > 0 && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    noWrap: true,
    langKey: "returnsItemListIneligibleDescription",
    defaultString: returnsItemListIneligibleDescription
  })), ineligibleItems.map(item => {
    var _item$eligibilities$r;
    return /*#__PURE__*/React__default["default"].createElement(ItemCard.ItemCard, {
      thumbnail: item.imageUrl ?? '',
      title: item.name,
      attributes: helper.getItemAttrs({
        locale,
        includeCurrency,
        item: {
          ...item,
          quantity: item.remainingQuantity
        },
        itemDisplay,
        labels: {
          skuLabel,
          qtyLabel,
          colorLabel,
          sizeLabel
        }
      }),
      hasShippingProtection: item.hasShippingProtection,
      additionalInfo: ((_item$eligibilities$r = item.eligibilities.return) === null || _item$eligibilities$r === void 0 ? void 0 : _item$eligibilities$r.message) ?? '',
      key: `${item.sku ?? ''}${item.itemId ?? ''}`,
      disabled: true,
      sDefault: {
        ...sDefault,
        backgroundColor: documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor
      }
    });
  })), (selectedItems && selectedItems.length > 0 || disclaimer) && /*#__PURE__*/React__default["default"].createElement(StickyFooter["default"], null, /*#__PURE__*/React__default["default"].createElement(Footer["default"], {
    onEvent: handleSubmit,
    progressiveStep: progressiveStep,
    activeStep: activeStep,
    above: disclaimer,
    buttons: {
      centerButton: {
        label: submitLabel,
        disabled: !(selectedItems !== null && selectedItems !== void 0 && selectedItems.length)
      }
    }
  })));
};
const ItemSelectorRaw = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(ItemSelectorRawC, {
  themeTokens: tokens.themeTokens
}), {
  translationKeys: tokens.translationKeys
}), {
  settingsRequested: `
      itemDisplay {
        additionalItemAttributeConfig {
          attribute
          value {
            concatKey
            concatPosition
            label
            transform
          }
        }
        itemAttributeConfig
      }
    `
});

exports.ItemSelectorRaw = ItemSelectorRaw;
